import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Environment } from '../../environments/environment';
import { IPilotPayHttpClient, IPilotPayRequestOptions } from './pilotpay-http-client.types';
const env: Environment = new Environment();

/**
 * Pilot Pay http client that handles modifying requests and responses to and from API
 */
@Injectable()
export class PilotPayHttpClient implements IPilotPayHttpClient {
	constructor(private http: HttpClient) {}

	/**
	 * getRequest
	 */
	public getRequest<T>(apiUrl: string): Observable<T> {
		const options: IPilotPayRequestOptions = this.createRequestOptions();
		const fullUrl: string = env.getConfiguration().apiBasePath + apiUrl;

		return this.http.get<T>(fullUrl, options);
	}

	public postRequest<T>(apiUrl: string, payload: Object, isFileResponse: boolean = false): Observable<T> {
		const options: IPilotPayRequestOptions = this.createRequestOptions();
		const fullUrl: string = env.getConfiguration().apiBasePath + apiUrl;

		if (isFileResponse) {
			options.responseType = 'blob';
		}

		return this.http.post<T>(fullUrl, payload, options);
	}

	public putRequest<T>(apiUrl: string, payload: Object): Observable<T> {
		const options: IPilotPayRequestOptions = this.createRequestOptions();
		const fullUrl: string = env.getConfiguration().apiBasePath + apiUrl;

		return this.http.put<T>(fullUrl, payload, options);
	}

	/**
	 * deleteRequest
	 */
	public deleteRequest<T>(apiUrl: string): Observable<T> {
		const options: IPilotPayRequestOptions = this.createRequestOptions();
		const fullUrl: string = env.getConfiguration().apiBasePath + apiUrl;

		return this.http.delete<T>(fullUrl, options);
	}

	/**
	 * createRequestOptions
	 */
	private createRequestOptions(): IPilotPayRequestOptions {
		let headers: HttpHeaders = new HttpHeaders();
		headers = headers.append(
			'Accept',
			'text/html,application/json,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8'
		);
		headers = headers.append('Content-Type', 'application/json');
		// Ensures GET requests retrieve new data request.
		const params: HttpParams = new HttpParams();

		return { headers: headers, params: params, withCredentials: true, reportProgress: true };
	}
}
